// Session helpers -- load the signed-in user's role + companies, and
// expose helpers for choosing / persisting the "active" company.
//
// For a staff user, role='staff' and companies=[] (they see everything).
// For a client user, companies is the list of sites they can act for.
import { supabase, isDemoMode } from './supabase'

export async function loadSessionContext(userId) {
  if (isDemoMode || !userId) {
    return { role: 'staff', companies: [], profile: null }
  }
  const [{ data: profile }, { data: links }] = await Promise.all([
    supabase.from('user_profiles').select('*').eq('user_id', userId).maybeSingle(),
    supabase.from('user_companies').select('company_id, companies(id, name, brand_settings_id)').eq('user_id', userId),
  ])
  const companies = (links || []).map(l => l.companies).filter(Boolean)
  return {
    role: profile?.role || 'client',
    profile,
    companies,
  }
}

const ACTIVE_KEY = 'wgop_active_company'

export function getActiveCompanyId() {
  return sessionStorage.getItem(ACTIVE_KEY) || null
}
export function setActiveCompanyId(id) {
  if (id) sessionStorage.setItem(ACTIVE_KEY, id)
  else sessionStorage.removeItem(ACTIVE_KEY)
}
